const { createApp, ref, nextTick } = Vue;

createApp({
    data() {
        return {
            step: 1,
            mobile_number: '',
            timer: 0,
            timerInterval: null,
            otp: ['', '', '', '', '', ''],
            errors: {},
            isSendingOtp: false,
            isVerifyingOtp: false,
        }
    },
    mounted() {
        // this.step = 3
    },
    methods: {
        triggerToast(type, text = '', pos = "top-right") {
            const arr = {
                'info': '#2196f3',
                'success': '#1abc9c',
                'error': '#e7515a'
            };
            Snackbar.show({
                text: text,
                pos: pos,
                actionTextColor: '#fff',
                backgroundColor: arr[type] || '#000'
            });
        },
        sendOtp() {
            if (!this.mobile_number) {
                // Swal.fire({
                //     icon: 'error',
                //     title: 'Error',
                //     text: "Please Enter Mobile Number",
                // });
                this.step = 1;
                this.triggerToast('info', 'Please Enter Mobile Number');
                return;
            }
            if (!/^[6-9][0-9]{9}$/.test(this.mobile_number)) {
                this.errors.mobile_number = ['Please enter a valid 10 digit mobile number.'];
                return;
            }
            this.sendOtpAPI();
        },
        back() {
            this.step = 1;
            this.otp = ['', '', '', '', '', ''];
        },
        sendOtpAPI() {
            if (this.isSendingOtp) return;

            this.errors = {};
            this.isSendingOtp = true;
            axios.post('/login/send-otp', {
                mobile_number: this.mobile_number,
            }).then(response => {
                let decodedData = atob(response.data.data);
                let data = JSON.parse(decodedData);
                if (data.status) {
                    this.triggerToast('success', 'OTP Sent Successfully');
                    this.step = 2;
                    this.startTimer();
                    nextTick(() => {
                        if (this.$refs.otpInputs && this.$refs.otpInputs[0]) {
                            this.$refs.otpInputs[0].focus();
                        }
                    });
                    return;
                }
                this.triggerToast('error', 'Something Went Wrong 2');
            }).catch(error => {
                // console.error("sendOtpAPI call error:", error);
                if (error.status === 429) {
                    this.triggerToast('info', 'Too many requests. Please try again later.');
                    return;
                }
                if (error.status === 422 && error.response.data && error.response.data.errors) {
                    this.errors = error.response.data.errors;
                    // let errors = error.response.data.errors;
                    // let firstErrorKey = Object.keys(errors)[0];
                    // this.triggerToast('info', errors[firstErrorKey][0]);
                    return;
                }
                this.triggerToast('error', 'Something Went Wrong');
            }).finally(() => {
                this.isSendingOtp = false;
            });
        },
        verifyOtp() {
            if (this.isVerifyingOtp) return;

            this.errors = {};
            const otpValue = this.otp.join('');
            if (otpValue.length < this.otp.length) {
                this.triggerToast('info', 'Please enter full OTP');
                return;
            }

            this.isVerifyingOtp = true;
            axios.post('/login/verify-otp', {
                mobile_number: this.mobile_number,
                otp: otpValue,
            }).then(response => {
                let decodedData = atob(response.data.data);
                let data = JSON.parse(decodedData);
                if (data.status) {
                    this.triggerToast('success', 'OTP Verified Successfully');
                    this.step = 3;
                    if (data.redirect_url) {
                        nextTick(() => {
                            const dotSpan = document.getElementById('redirect_dots');
                            if (dotSpan) {
                                let dotCount = 1;
                                const dotInterval = setInterval(() => {
                                    dotSpan.textContent = '.'.repeat(dotCount);
                                    dotCount = dotCount >= 3 ? 1 : dotCount + 1;
                                }, 500);

                                setTimeout(() => {
                                    window.location.href = data.redirect_url;
                                }, 2000);
                            }
                        });
                    }
                    return;
                } else {
                    this.triggerToast('error', data.message ?? 'Invalid OTP');
                }
            }).catch(error => {
                // console.error("verifyOtp call error:", error);
                if (error.status === 429) {
                    this.triggerToast('info', 'Too many requests. Please try again later.');
                    return;
                }
                if (error.status === 422 && error.response.data && error.response.data.errors) {
                    let errors = error.response.data.errors;
                    if (errors.otp) {
                        Object.keys(errors).forEach(key => {
                            this.triggerToast('error', errors[key][0]);
                        });
                    } else {
                        this.errors = errors;
                        this.triggerToast('info', 'Validation Error. Please check the form.');
                        this.step = 1;
                        this.otp = ['', '', '', '', '', ''];
                    }
                    return;
                } else {
                    this.triggerToast('error', 'Something Went Wrong');
                }
            }).finally(() => {
                this.isVerifyingOtp = false;
            });
        },
        startTimer() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
            }
            this.timer = 30;
            this.timerInterval = setInterval(() => {
                if (this.timer > 0) {
                    this.timer--;
                } else {
                    clearInterval(this.timerInterval);
                    this.timerInterval = null;
                }
            }, 1000);
        },
        moveToNext(event, index) {
            const value = event.target.value;
            if (value.length === 1 && index < this.otp.length - 1) {
                this.$refs.otpInputs[index + 1].focus();
            }
        },
        moveToPrev(event, index) {
            if (event.target.value === '' && index > 0) {
                this.$refs.otpInputs[index - 1].focus();
            }
        },
    }
}).mount('#app');